// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d0e8e58a","container":"a063b00c","selectContainer":"f436d12e","button":"a38c88fa","selected":"d775c3d2","text":"c08873f5"};